// Money as a quote line takes it (Stephanie 2026-10-26: adding a catalogue
// product failed with "HTTP 400"). The API takes a cost to 3 decimals and a
// sell price to the cent; catalogue prices can carry more (e.g. 2.6250 or
// 2.625). Pure — the offline gate runs it.

/** A cost to at most 3 decimals ("2.6250" → "2.625", "1.17" stays). */
export function lineCost(v: string | number): string {
  const n = Number(v);
  if (!Number.isFinite(n)) return "0";
  return String(Math.round(Number((n * 1000).toFixed(6))) / 1000);
}

/** A sell price to the cent ("2.625" → "2.63"). */
export function linePrice(v: string | number): string {
  const n = Number(v);
  if (!Number.isFinite(n)) return "0.00";
  return (Math.round(Number((n * 100).toFixed(6))) / 100).toFixed(2);
}

/** The margin new product lines are priced at when the quote has none of its
 *  own (Stephanie 2026-10-26: "put the default margin as 40%"). */
export const DEFAULT_MARGIN_PCT = 40;

/** Pure: the quote's own default margin if it has a usable one, else 40%. */
export function effectiveMarginPct(quotePct: string | null | undefined): number {
  const n = quotePct === null || quotePct === undefined || quotePct.trim() === "" ? NaN : Number(quotePct);
  return Number.isFinite(n) && n >= 0 && n < 100 ? n : DEFAULT_MARGIN_PCT;
}

/** Pure: sell price from cost at a margin, to the cent (40% → cost / 0.60). */
export function sellAtMargin(cost: string | number, marginPct: number): string {
  return linePrice(Number(cost) / (1 - marginPct / 100));
}
